import { useEffect, useState } from 'react';
type A = { who: string; surface: string; query_json: string; rows: number; at: number };
export default function CdrAudit() {
  const [rows, setRows] = useState<A[]>([]);
  const [err, setErr] = useState<string | null>(null);
  useEffect(() => {
    fetch('/cdr/api/audit', { credentials: 'include' }).then(async r => {
      if (r.status === 403) { setErr('Admins only.'); return; }
      if (!r.ok) { setErr('Failed (' + r.status + ')'); return; }
      const j = await r.json(); setRows(j.audit || []);
    }).catch(e => setErr(e?.message ?? 'failed'));
  }, []);
  function fmtQuery(q: string) { try { const o = JSON.parse(q); delete o.limit; delete o.token; return Object.entries(o).map(([k, v]) => `${k}=${v}`).join(' · ') || '(all)'; } catch { return q; } }
  return (
    <div className="space-y-3">
      <div className="text-sm text-gray-500">Search audit — every CDR search/export/analytics run is logged here for accountability.</div>
      {err && <div className="card p-3 text-sm text-tnh-err">{err}</div>}
      <div className="card overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-xs text-gray-500 uppercase tracking-wide"><tr className="border-b border-tnh-border dark:border-tnh-border-dark">
            <th className="text-left px-4 py-2">When</th><th className="text-left px-4 py-2">Who</th><th className="text-left px-4 py-2">Action</th><th className="text-left px-4 py-2">Query</th><th className="text-right px-4 py-2">Rows</th></tr></thead>
          <tbody>
            {rows.length === 0 && !err && <tr><td colSpan={5} className="text-center text-gray-500 py-8">No searches recorded yet.</td></tr>}
            {rows.map((r, i) => (<tr key={i} className="border-b last:border-b-0 border-tnh-border/40 dark:border-tnh-border-dark/40">
              <td className="px-4 py-2 text-xs whitespace-nowrap">{new Date(r.at).toLocaleString()}</td>
              <td className="px-4 py-2 text-xs">{r.who}</td>
              <td className="px-4 py-2 text-xs"><span className="pill bg-gray-100 dark:bg-gray-800">{r.surface}</span></td>
              <td className="px-4 py-2 text-xs text-gray-500">{fmtQuery(r.query_json)}</td>
              <td className="px-4 py-2 text-right text-xs">{r.rows}</td>
            </tr>))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
